module.exports = __webpack_public_path__ + "img/header_3.7ea4de8c.png";